export enum GoalsViewId {
    ALL             = 'all',
    ACTIVE          = 'active',
    ASSIGNED_GOALS  = 'assigned-goals',
    OWNED_GOALS     = 'owned-goals',
    ARCHIVED_GOALS  = 'archived-goals',
}

export const GoalsViewTitle = {
    [GoalsViewId.ACTIVE]            : 'Active',
    [GoalsViewId.ASSIGNED_GOALS]    : 'Assigned to me',
    [GoalsViewId.OWNED_GOALS]       : 'Owned by me',
    [GoalsViewId.ARCHIVED_GOALS]    : 'Archived',
    [GoalsViewId.ALL]               : 'All',
}